// regex.jsx

// 정규식 상수
export const REGEX = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  password:
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  phone: /^\+[1-9]\d{1,14}$/,
  name: /^[가-힣a-zA-Z\s]+$/,
  jamo: /^(?:[\u1100-\u11FF\u3130-\u318F])+$/u,
};

// 검증 메시지 상수
export const VALIDATION_MESSAGES = {
  email: {
    invalid: "올바른 이메일 형식을 입력해주세요.",
    valid: "올바른 이메일 형식입니다.",
  },
  password: {
    invalid:
      "비밀번호는 최소 8자 이상, 대/소문자, 숫자, 특수문자를 포함해야 합니다.",
    valid: "안전한 비밀번호입니다.",
  },
  passwordCheck: {
    invalid: "비밀번호가 일치하지 않습니다.",
    valid: "비밀번호가 일치합니다.",
  },
  company_name: {
    invalid: "브랜드명에 자모 단독 입력은 사용할 수 없습니다.",
    valid: "사용 가능한 브랜드명입니다.",
  },
  first_name: {
    invalid: "이름은 2자 이상, 한글/영문만 입력 가능합니다.",
    valid: "올바른 이름 형식입니다.",
  },
  last_name: {
    invalid: "성은 1자 이상, 한글/영문만 입력 가능합니다.",
    valid: "올바른 성 형식입니다.",
  },
  phone: {
    invalid: "올바른 전화번호 형식을 입력해주세요.",
    valid: "올바른 전화번호 형식입니다.",
  },
};

// 공용 유틸
export const cleanPhoneNumber = (phone) =>
  phone ? phone.replace(/[\s\-()]/g, "") : "";

// 검증 함수 모음
export const validators = {
  email: (value) => REGEX.email.test(value),
  password: (value) => REGEX.password.test(value),
  phone: (value) => REGEX.phone.test(cleanPhoneNumber(value || "")),
  name: (value) => REGEX.name.test(value) && String(value).trim().length >= 2,
  lastName: (value) =>
    REGEX.name.test(value) && String(value).trim().length >= 1,
  jamo: (value) => REGEX.jamo.test(value),
};

/**
 * 단일 필드 검증 (기존 로직 그대로)
 * @param {string} name - 필드명
 * @param {string} value - 값
 * @param {{password?: string}} ctx - passwordCheck 비교용 컨텍스트
 * @returns {{isValid:boolean, message:string}}
 */
export const validateField = (name, value, ctx = {}) => {
  if (!value) return { isValid: false, message: "" };

  const fieldMessages = VALIDATION_MESSAGES[name];
  if (!fieldMessages) return { isValid: false, message: "" };

  let isValid = false;
  switch (name) {
    case "email":
      isValid = validators.email(value);
      break;
    case "password":
      isValid = validators.password(value);
      break;
    case "passwordCheck":
      isValid = value === (ctx.password || "");
      break;
    case "company_name":
      isValid = !validators.jamo(value);
      break;
    case "first_name":
      isValid = !validators.jamo(value) && validators.name(value);
      break;
    case "last_name":
      isValid = !validators.jamo(value) && validators.lastName(value);
      break;
    case "phone":
      isValid = validators.phone(value);
      break;
    default:
      return { isValid: false, message: "" };
  }

  return {
    isValid,
    message: isValid ? fieldMessages.valid : fieldMessages.invalid,
  };
};
